var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white"}},[_c('property-form',{attrs:{"value":_vm.value ||
      ['fio', 'user_id'].reduce((a, v) => {
        a[v] = '';
        return a;
      }, {}),"fields":_vm.fields},on:{"input":_vm.doSave}}),_c('error-message-wrapper',{ref:"error_wrapper"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }